export default __webpack_public_path__ + "static/media/crown_of_insight.de75cb81.png";